import React, { Component } from "react";
import EmbEdad from "./EmbEdad";
import EmbRiesgoObs from "./EmbRiesgoObs";
import EmbTrimGest from "./EmbTrimGest";
import EmbComor from "./EmbComor";

export default class PanelPerfilEmb extends Component {

  render() {
    const {unidad_medica_user}= this.props;

    return(
      
      unidad_medica_user !== "" &&
        <div className="grid-container-fvg">
          <div className="grid-item-fvg">
            <span className="format-titles-pnl">Edad de las mujeres embarazadas</span>  
            <EmbEdad {...this.props}/>
            <span className="pnl-format-pie">Años</span>  
          </div>
          <div className="grid-item-fvg">  
            <span className="format-titles-pnl">Riesgo obstétrico</span>  
            <EmbRiesgoObs {...this.props}/>
            <div
            className="container-square"
            >
              <div className="square_blue_pnl">
              </div>
              <span className="pnl-format-pie">Pacientes</span>  
            </div>
          </div>
          <div className="grid-item-fvg">
            <span className="format-titles-pnl">Trimestre de gestación</span>  
            <EmbTrimGest {...this.props}/>
            <span className="pnl-format-pie">Pacientes</span>  
          </div>
          <div className="grid-item-fvg">
            <span className="format-titles-pnl">Comorbilidades</span>
              <EmbComor {...this.props}/>
          </div>
        </div>
    );    
  }
}
